import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { mangaList } from "@/mocks/manga";

const icons: Record<string, string> = {
  热血冒险: "ri-flashlight-fill",
  都市奇幻: "ri-building-2-fill",
  治愈美食: "ri-restaurant-fill",
  青春校园: "ri-school-fill",
  国风志怪: "ri-landscape-fill",
  科幻冒险: "ri-rocket-2-fill",
  恋爱治愈: "ri-heart-3-fill",
  推理悬疑: "ri-search-eye-fill",
  武侠江湖: "ri-sword-fill",
  音乐励志: "ri-music-2-fill",
};

export default function GenreSection() {
  const genres = Array.from(new Set(mangaList.flatMap((m) => [m.genre])));
  const total = genres.length;

  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="题材分类"
        title="按你的口味浏览"
        desc="从热血到治愈，从国风到科幻，选择你喜欢的题材，快速发现同类型的优质作品。"
      />
      <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
        {genres.map((g, i) => {
          const sample = mangaList.find((m) => m.genre === g);
          return (
            <Link
              key={g}
              to={`/manga?genre=${encodeURIComponent(g)}`}
              className="group relative aspect-[4/3] overflow-hidden rounded-xl border border-background-200"
            >
              <img
                src={sample?.cover}
                alt={`${g}漫画分类`}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 p-4">
                <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-white/15 text-background-50 backdrop-blur-sm">
                  <i className={icons[g] || "ri-book-2-fill"} aria-hidden="true"></i>
                </span>
                <h3 className="mt-2 font-heading text-base font-bold text-background-50">
                  {g}
                </h3>
                <p className="text-xs text-background-100/85">{sample?.chapters} 部代表作品</p>
              </div>
            </Link>
          );
        })}
      </div>
      <p className="mt-4 text-sm text-foreground-500">
        已收录 {total} 大题材分类，更多细分标签正在持续更新中。
      </p>
    </section>
  );
}